<!-- 瀑布流加载图片 -->
<template>
  <div>
    <div class="waterfall clearfix">
      <div class="no_content" v-show="isLoaded && picInfo==''&&picInfo.length==0">
        <img src="../../assets/img/no_search.png" />
        <p>没有找到符合条件的结果</p>
      </div>
      <!-- <div class="loading" v-show="loading&&picInfo.length>0">
                <img src="../../../static/loading.gif" />
                <p>您访问的页面正在加载中，请耐心等待~</p>
            </div> -->
      <div id="waterfall" ref="waterfalls">
        <div class="item" v-for="(pic,index) in picInfo" :key="index" ref="item" :id="pic.SourceID" :class="{active: pic.FileType==3}">
          <!-- <router-link tag="div" :to="pic.SourceType==1? (pic.FileType!=3? '/picDetail?id='+pic.SourceID+'&sourceType='+pic.SourceType+'&fId='+pic.Id: curentPath):'/artDetail?id='+pic.SourceID+'&sourceType='+pic.SourceType"> -->
          <!--收藏  -->
          <div class="pick" @click.stop="showCollect(index,pic.SourceID,1,pic.SourceType,pic.Id)" v-show="isPick">
            <i class="icon_add"></i>收藏
          </div>
          <!--个人主页  原创作品 编辑 跳页 -->
          <router-link :to="pic.FileType==1?'/share/photo?uid='+pic.UserId+'&fileId='+pic.SourceID:pic.FileType==0?'/share/artical?uid='+pic.UserId+'&fileId='+pic.SourceID:'/share/ppt?uid='+pic.UserId+'&fileId='+pic.SourceID" class="edit" v-show="isEdit">编辑</router-link>
          <!--个人主页  收藏 编辑  -->
          <div class="edit" v-show="isEdits" @click.stop="showCollect(index,pic.FileComprehensiveId,2)">编辑</div>
          <!--个人主页  删除  -->
          <div class="pick" v-show="isDelete" @click.stop="openDeleteFile(pic.SourceID,pic.SourceType,index)">删除</div>
          <router-link tag="a" :target="pic.FileType==3?'':'_blank'" :to="pic.SourceType==1? 
                            (pic.FileType!=3? '/picDetail?id='+pic.SourceID+'&sourceType='+pic.SourceType+'&fId='+pic.Id: curentPath):
                            '/artDetail?id='+pic.SourceID+'&sourceType='+pic.SourceType" class="img_box">
            <img v-lazy="pic.CoverImg" lazy :key="pic.CoverImg" width="305" :height="countNum(pic.CoverImgWidth,pic.CoverImgHeight)" />
            <!-- <div class="img" v-lazy:background-image="pic.CoverImg" style="width:305px" :style="{height:(countNum(pic.CoverImgWidth,pic.CoverImgHeight)+'px')}"></div> -->
            <!-- <img :src="imgArr[index]" class="cover_img" width="305"   :height="countNum(pic.CoverImgWidth,pic.CoverImgHeight)"/> -->
            <!--用户审核 1审核中 2审核通过 3审核不通过  -->
            <div v-show="pic.Status&&pic.Status!=2&&pic.CategoryName=='免版权素材'" class="examine_txt">
              <span>{{pic.Status==1?'审核中':(pic.Status==2?'审核通过':'审核不通过')}}</span>
            </div>
          </router-link>
          <!--bottom  -->
          <div class="waterfall_con" :class="{'down_con':(pic.FileType==3||pic.FileType==4||pic.FileType==6)}">
            <p class="title">{{pic.Title}}</p>
            <p class="classify" v-show="pic.FileType!=3&&pic.FileType!=4&&pic.FileType!=6">{{pic.CategoryName}}</p>
            <div class="down" v-show="pic.FileType==3||pic.FileType==4||pic.FileType==6" @click.stop="fileDown(pic.Id,1)">立即下载</div>
            <div class="icon_box clearfix">
              <!--下载数  -->
              <div v-show="(pic.DownLoadCount!=null)&&(pic.FileType!=3&&pic.FileType!=4&&pic.FileType!=6)&&pic.SourceType!=2">
                <span class="icon">
                  <i class="icon_down"></i>{{pic.DownLoadCount}}</span>
              </div>
              <!--评论与点赞  -->
              <div v-show="(pic.WordsCount!=null&&pic.LikeCount!=null)&&(pic.FileType!=3&&pic.FileType!=4&&pic.FileType!=6)">
                <span class="icon">
                  <i class="icon_comment"></i>{{pic.WordsCount}}</span>
                <span class="icon">
                  <i class="icon_thumbs"></i>{{pic.LikeCount}}</span>
              </div>

            </div>
            <!--用户信息  -->
            <router-link tag="div" :to="pic.UserId!=userId?'/personInfo/original?uid='+pic.UserId:'/homepage'">
              <div class="user" v-show="pic.FileType!=3&&pic.FileType!=4&&pic.FileType!=6">
                <img :src="pic.Avatar" class="user_head" />
                <span>{{pic.JobNo}}</span>&nbsp;&nbsp;&nbsp;&nbsp;
                <span>{{pic.Name}}</span>
              </div>
            </router-link>

          </div>
          <!-- </router-link> -->
        </div>
      </div>
    </div>
    <div>
      <div ref="click_more" class="click_more" v-if="maxResult<totalNum&&pageNum!=parseInt(totalNum/maxResult)">
      <!-- <div ref="click_more" class="click_more" v-if="maxResult<totalNum&&pageNum!=parseInt(totalNum/maxResult)" @click="loadMore()"> -->
        <img src="../../../static/load_more.gif" />
        <p>{{clickTxt}}</p>
      </div>
      <div class="click_more" v-else-if="pageNum!=0">没有更多了</div>
    </div>
    <collect :isDialogShow="isCollectShow" :userId="userId" :fileId="fileId" :sourceId="sourceId" :sourceType="sourceType" :fileCoverImg="fileCoverImg" :type="collectType" @closeCollectDialog="closeCollect"></collect>
    <warn ref="warn"></warn>
    <confirm ref="confirm" @handelConfirm="handelConfirm"></confirm>
    <login :isShow="logShow" :bgShow="false" @close="logClose"></login>
  </div>
</template>
 
<script>
import { getFilePic } from "../../assets/js/modules/fileApi"
import { getOriginalList, getCollectDetail, deleteOriginal } from "../../assets/js/modules/userApi"
import { downFileFirst } from "../../assets/js/modules/articleApi"
import Collect from "./collect.vue"
import Warn from "./warn.vue"
import Confirm from "./confirm.vue"
import login from "../common/login"
export default {
  inject: ['reload'],
  props: {
    gap: { // 瀑布流边距为20像素
      type: Number,
      default: 20
    },
    apiType: {//1---原创作品，2---收藏,3---符合条件的文件或文章
      type: Number,
      default: 1
    },
    isWaterfall: {//是否为瀑布流格式
      type: Boolean,
      default: true
    },
    favoritesId: {  //收藏夹Id
    },
    fileList: { //文件列表
      type: Object
    },
    // isPick: {  //显示收藏
    //     type: Boolean,
    //     default: false
    // },
    uId: {},
    sType: {//

      default: 1
    }
  },
  components: {
    Collect,
    Warn,
    Confirm,
    login
  },
  data() {
    return {
      userInfo: {},
      picInfo: [],
      isEdit: false, //原创作品显示编辑
      isEdits: false, //收藏显示编辑0
      isDelete: false, //显示删除
      isPick: false,//显示收藏
      isCollectShow: false, //收藏弹窗
      userId: "",
      fileId: "",
      sourceId: "",       //文件Id
      sourceType: 0,     //文件类型
      nowIndex: "",       //当前操作项下标
      fileCoverImg: "",
      collectType: 1,     //1--收藏, 2--编辑
      confirmValue: false,
      logShow: false,
      skipCount: 0, //跳过多少条
      maxResult: 30, //一页显示多少条
      totalNum: 0, //总共多少条
      pageNum: 0,
      clickMore: false,
      imgArr: [],
      curentPath: "",
      isLoaded: false,
      loading: true,
      clickTxt: "滑动加载更多",
      scollSign :false , //滚动加载  锁
    };
  },
  created() {
    this.getUserInfo();
    this.curentPath = this.$router.currentRoute.fullPath;//当前路由完整路径
    this.apiCheck();

  },
  mounted() {
    var self = this;
    // this.apiCheck()
    if (this.isWaterfall) {
      window.onresize = function () {
        self.waterfall()
      }
    }
    // setTimeout(() => {
    //     this.loading = false;
    // }, 500)

    this.$nextTick(() => {
      let timer;
      window.addEventListener("scroll", () => {
        if (this.isFixed) {
          this.isFixed = false;
        }
        if (timer) {
          clearTimeout(timer);
        }
        timer = setTimeout(() => {
          this.handleScroll();
        }, 500);
      }); 
      // this.handleScroll();
    });
  },
  methods: {
    //判断div是否在可视区域内
    isElementNotInViewport(el) {
      let rect = el.getBoundingClientRect();
      return (
        rect.top >= (window.innerHeight || document.documentElement.clientHeight) ||
        rect.bottom <= 0
      );
    },
    //滑动到底部加载列表
    handleScroll() {   
      // console.log('scollSign',this.scollSign);
      if (!this.isElementNotInViewport(this.$refs['click_more'])) { 
          if(!this.scollSign) {
                this.scollSign = true 
                this.loadMore()
            }
        }
    },
    waterfall() {//瀑布流
      // this.$nextTick(() => {
      var columnHeight = [];
      var margin = 22;
      const con = this.$refs.waterfalls;
      const boxes = this.$refs.item;
      if (!boxes || boxes.length == 0) return;
      var boxWidth = boxes[0].offsetWidth; //每个item的width
      var boxHeight = boxes[0].offsetHeight;
      var bodyWidth = con.offsetWidth;
      var n = Math.floor(bodyWidth / boxWidth); //每行最多放几张图片
      var columnNum = n == 0 ? 1 : n;
      var num = parseInt((boxes.length) / columnNum);
      var h = (boxes.length) % n > 0 ? 1 : 0;
      var colNum = num + h; //总共有多少列
      for (var i = 0, l = boxes.length; i < l; i++) {
        boxes[i].style.width = '305px';
        // boxes[i].style.height = boxWidth+'px';
        boxes[i].style.position = "absolute";
        if (i < columnNum) { //第一排
          columnHeight[i] = boxes[i].offsetHeight + margin;
          boxes[i].style.top = 0;
          boxes[i].style.left = i * (boxWidth + margin) + 'px';
        } else { //非第一排
          var innsertColumn = this.min(columnHeight),
            imgHeight = boxes[i].offsetHeight + margin;
          boxes[i].style.top = columnHeight[innsertColumn] + 'px';
          boxes[i].style.left = innsertColumn * (boxWidth + margin) + 'px';
          columnHeight[innsertColumn] += imgHeight;
        };

      };
      var maxCol = this.max(columnHeight);
      var maxHeight = columnHeight[maxCol]
      con.style.height = maxHeight + "px";
      // })

    },
    min(heightAarry) {//最小高度
      var minColumn = 0;
      var minHeight = heightAarry[minColumn];
      for (var i = 1, len = heightAarry.length; i < len; i++) {
        var temp = heightAarry[i];
        if (temp < minHeight) {
          minColumn = i;
          minHeight = temp;
        };
      };
      return minColumn;
    },
    max(heightAarry) {//最大高度
      var maxColumn = 0;
      var maxHeight = heightAarry[maxColumn];
      for (var i = 1, len = heightAarry.length; i < len; i++) {
        var temp = heightAarry[i];
        if (temp > maxHeight) {
          maxColumn = i;
          maxHeight = temp;
        };
      };
      return maxColumn;

    },
    countNum(width, height) {
      var relHeight = Math.round((305 * height) / width);
      return relHeight;
    },
    getUserInfo() { //用户信息
      if (JSON.parse(localStorage.getItem('userInfo'))) {
        this.userInfo = JSON.parse(localStorage.getItem('userInfo'));
        this.userId = this.userInfo.Id;
      } else {
        return;
      }
      // console.log(this.userId + "userId")
    },
    showCollect(index, fileId, type, sourceType, id) {//显示收藏
      if (JSON.parse(localStorage.getItem('userInfo'))) {
        this.logShow = false;
        this.sourceType = sourceType;
        this.collectType = type;
        this.fileId = fileId;
        this.fileCoverImg = this.picInfo[index].CoverImg;
        this.isCollectShow = true;
        this.sourceId = id || "";
      } else {
        this.isCollectShow = false;
        this.logShow = true;
      }

    },
    closeCollect(data) { //关闭收藏
      this.isCollectShow = false;
      if (data) {
        this.$refs.warn.message(data.text);
      }
    },
    closeWarn() { //关闭提示框
      this.$refs.warn.closeWarn();
    },
    handelConfirm(data) {
      this.$refs.confirm.closeConfirm();
      this.confirmValue = data.handel;
    },
    openDeleteFile(id, sourceType, index) { //打开删除框
      this.fileId = id;
      this.sourceType = sourceType;
      this.nowIndex = index;
      this.$refs.confirm.openConfirm("删除文件将会删除与之相关的所有内容<br/>你确定要删除吗？");
    },
    deleteFile() { //删除文件
      let data = {
        UserId: this.userId,
        SourceID: this.fileId,
        SourceType: this.sourceType
      };
      deleteOriginal(data).then(res => {
        if (res.data.Success) {
          this.picInfo.splice(this.nowIndex, 1);
          this.imgArr.splice(this.nowIndex, 1);
          this.$refs.warn.message("删除成功!");
        }
      })
    },
    logClose() { //关闭登录
      this.logShow = false;
    },
    loadMore() { //点击加载更多
      this.clickMore = true;
      this.apiCheck();
      // this.clickTxt="加载更多";
    },
    loadImg(arr) {//图片加载后显示
      if (!arr || arr.length == 0) return;
      let count = 0;
      for (var i = 0; i < arr.length; i++) {
        this.imgArr[i] = arr[i].CoverImg;
        let img = document.createElement("img");
        img.src = this.imgArr[i];
        img.onload = () => {
          count++;
          // this.loading = false;
          if (count == arr.length) {
            this.loading = false;
            // this.waterfall();

          } else {
            this.loading = true;
          }
        }
      }
    },
    apiCheck() {
      var self = this;
      let originalList = {
        UserId: this.uId,
      }
      let data = {};
      if (this.sType == 1) {//文件
        data = {
          SourceType: 1,
          FileType: 1
        }
      } else if (this.sType == 2) {//文章
        data = {
          SourceType: 2
        }
      } else {//PPT
        data = {
          SourceType: 1,
          FileType: 4
        }
      }
      if (this.apiType === 1) { //原创作品
        if (this.clickMore) {
          this.skipCount += this.maxResult;
          this.pageNum = parseInt(this.skipCount / this.maxResult);
        }
        getOriginalList({ ...originalList, ...data, SkipCount: this.skipCount, MaxResultCount: this.maxResult }).then(res => {
          // console.log(res)
          if (res.data.Code == 1) {
            if (this.uId == this.userId) {
              self.isEdit = true;
              self.isDelete = true;
            } else {
              self.isPick = true;
            }
            if (!res.data.Data) return;
            if (this.clickMore) {
              self.picInfo = self.picInfo.concat(res.data.Data.Items);
            } else {
              self.picInfo = res.data.Data.Items;
            }
            // self.picInfo = res.data.Data.Items;
            self.totalNum = res.data.Data.TotalCount;
            // self.fileId = res.data.Data.Items
            this.$emit('getListLength', this.picInfo.length);
            // this.$nextTick(()=>{
            //      this.waterfall();
            // })
            // this.loadImg(this.picInfo);
            this.$nextTick(() => {
              this.waterfall()
            })
            // if (this.isWaterfall ) {
            //     setTimeout(function() {
            //         self.waterfall()
            //     }, 300);
            // } 
          }
          this.scollSign = false 
        })
      } else if (this.apiType === 2) {    //收藏详情列表
        if (this.clickMore) {
          this.skipCount += this.maxResult;
          this.pageNum = parseInt(this.skipCount / this.maxResult);
        }
        let data = { UserId: this.uId, FavoritesId: this.favoritesId };
        getCollectDetail({ ...data, SkipCount: this.skipCount, MaxResultCount: this.maxResult }).then(res => {
          if (res.data.Code == 1) {
            self.isPick = true;
            if (this.uId == this.userId) {
              self.isEdits = true;
            }
            if (this.clickMore) {
              self.picInfo = self.picInfo.concat(res.data.Data.Items);
            } else {
              self.picInfo = res.data.Data.Items;
            }
            // this.picInfo = res.data.Data.Items;
            self.totalNum = res.data.Data.TotalCount;
            this.$emit('getListLength', this.picInfo.length);
            // this.loadImg(this.picInfo);
            this.$nextTick(() => {
              this.waterfall()
            })
            // if (this.isWaterfall) {
            //     setTimeout(function() {
            //         self.waterfall()
            //     }, 300);
            // }
          }
          this.scollSign = false 
        })
      } else if (this.apiType === 3) { //获取符合条件的图片列表
        if (this.clickMore) {
          self.skipCount += this.maxResult;
          this.pageNum = parseInt(this.skipCount / this.maxResult);
        }
        getFilePic({ ...this.fileList, SkipCount: this.skipCount, MaxResultCount: this.maxResult }).then(res => {
          if (res.data.Code == 1) {
            if (this.clickMore) {
              self.picInfo = self.picInfo.concat(res.data.Data.listFile);
            } else {
              self.picInfo = res.data.Data.listFile;
            }
            // self.picInfo = res.data.Data.listFile;
            self.totalNum = res.data.Data.total;
            this.$emit("totalNum", this.totalNum);
            self.isPick = true;
            this.$nextTick(() => {
              this.waterfall()
            })
            this.isLoaded = true;
            this.scollSign = false 
            // this.loadImg(this.picInfo);
            // if (this.isWaterfall) {
            //     setTimeout(function() {
            //         self.waterfall()
            //     }, 300);
            // }
          }
        })
      }
    },
    fileDown(fileId, FileDetailType) { //下载源文件
      let down = {
        FileId: fileId,
        FileDetailType: FileDetailType  //（1使用文件  2使用规范文件  3输出文件  4授权文件  5设计交流源文件)
      };
      downFileFirst(down).then(res => {
        if (res.data.Code == 1) {
          let url = process.env.BASE_API + "/api/UpLoadFile/DownloadSecondAsync?Identity=" + res.data.Data;
          window.location.href = url;
        }else {
          this.$warn({
            warnText: '您的账户没有权限，熊出没相关资料需24级以上账户方可下载',
            isShow: true
          });
        }
      })
    }
  },
  watch: {
    confirmValue: {
      handler: function () {
        if (this.confirmValue) {
          this.deleteFile();
          this.isConfirmShow = false;
        }
        this.confirmValue = false;
      },
      immediate: true
    },
    $route(to, from) {
    }
  }

}

</script>
<style  scoped>
* {
  box-sizing: border-box;
}

.waterfall {
  max-width: 1280px;
  margin: 20px auto;
  position: relative;
  min-height: 780px;
}

.pick {
  width: 60px;
  height: 28px;
  line-height: 28px;
  background: #ff5a5a;
  border-radius: 50px;
  font-size: 12px;
  color: #fff;
  text-align: center;
  position: absolute;
  top: 10px;
  left: 15px;
  opacity: 0;
  cursor: pointer;
  z-index: 99;
}

.edit {
  width: 60px;
  height: 28px;
  line-height: 28px;
  background: rgba(0, 0, 0, 0.5);
  border-radius: 50px;
  font-size: 12px;
  color: #fff;
  text-align: center;
  position: absolute;
  top: 10px;
  right: 15px;
  opacity: 0;
  cursor: pointer;
  z-index: 99;
}

.icon_add {
  width: 10px;
  height: 10px;
  display: inline-block;
  background: url("../../assets/img/icon_add.png") no-repeat;
  margin-right: 6px;
}

.item {
  float: left;
  position: relative;
  margin: 0 20px 20px 0;
  box-shadow: 0px 0px 10px 5px rgba(233, 233, 233, 0.5);
  background: #fff;
  /* position: absolute; */
  width: 305px;
  border-radius: 10px;
  overflow: hidden;
  transition: all 0.3s ease-out;
  animation: show-card-data-v-cc0e62e4 0.4s;
  /* cursor: pointer; */
}

.item.active {
  cursor: default;
}

/* .item:nth-child(4n) {
     margin-right: 0; 
}
.item:nth-child(5) {
     height:100px ;
} */

.item:hover {
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.02),
    0 16px 32px -4px rgba(0, 0, 0, 0.17);
  transform: translateY(-2px);
}

.item:hover .pick {
  opacity: 1;
}

.item:hover .edit {
  opacity: 1;
}

.pick:hover {
  background: #e31725;
}

.edit:hover {
  background: rgba(0, 0, 0, 0.8);
}

.img_box {
  display: block;
  position: relative;
}

.item img {
  max-width: 100%;
  max-height: 100%;
}

.cover_img {
  width: 100%;
  cursor: pointer;
}

.waterfall_con {
  width: 100%;
  height: 158px;
  padding: 0 15px;
  overflow: hidden;
}

.waterfall_con.down_con {
  height: auto;
}

.down_con .down {
  display: block;
  width: 86px;
  height: 32px;
  line-height: 32px;
  border: 1px solid #ff9a35;
  color: #999;
  border-radius: 50px;
  margin-bottom: 10px;
  text-align: center;
  cursor: pointer;
  float: right;
  margin-top: 10px;
}

.down_con .down:hover {
  background: #ff9a35;
  color: #fff;
}

.waterfall_con .title {
  color: #666;
  font-size: 16px;
  margin-top: 10px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.waterfall_con .classify {
  color: #999;
  font-size: 12px;
}

.icon_box {
  margin-top: 20px;
  font-size: 12px;
  color: #ccc;
}

.icon {
  margin-right: 20px;
}

.icon_comment {
  width: 16px;
  height: 16px;
  display: inline-block;
  background: url("../../assets/img/icon_comment.png") no-repeat;
  position: relative;
  top: 4px;
  margin-right: 5px;
}

.icon_thumbs {
  width: 16px;
  height: 16px;
  display: inline-block;
  background: url("../../assets/img/icon_thumbs.png") no-repeat;
  position: relative;
  top: 4px;
  margin-right: 3px;
}

.examine_txt {
  position: absolute;
  bottom: 0;
  left: 0;
  width: 100%;
  height: 48px;
  line-height: 48px;
  background: rgba(0, 0, 0, 0.7);
  text-align: center;
  color: #fff;
  font-size: 20px;
}
.icon_down {
  width: 17px;
  height: 15px;
  display: inline-block;
  background: url("../../assets/img/icon_down.png") no-repeat;
  /* position: relative;
    top: 3px; */
  margin-right: 3px;
}

.user {
  font-size: 12px;
  color: #666;
  width: 100%;
  height: 52px;
  line-height: 52px;
  position: absolute;
  bottom: 0;
  left: 0;
  border-top: 1px solid #e5e5e5;
  cursor: pointer;
}

.user_head {
  width: 36px;
  height: 36px;
  border-radius: 50%;
  float: left;
  margin: 8px 15px 0 15px;
}

.click_more {
  padding: 10px;
  width: 49%;
  font-size: 16px;
  color: #999;
  margin: 20px auto;
  text-align: center;
  cursor: pointer;
}

.click_more p {
  margin-top: -38px;
}

.no_content {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  text-align: center;
  font-size: 18px;
  color: #999;
}

.no_content p {
  margin-top: 20px;
}

.loading {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  text-align: center;
  font-size: 18px;
  color: #999;
}

@keyframes show-card-data-v-cc0e62e4 {
  0% {
    transform: scale(0.5);
  }
  100% {
    transform: scale(1);
  }
}
</style>



// WEBPACK FOOTER //
// src/components/common/waterfall.vue